// const Signin = () =>{
//     return (
//         <div>
//             <h1>Signin Page</h1>
//         </div>
//     );

// }
// export default Signin



import React, { Component } from 'react';
import style from './Signin.module.css';
//import logoImage from '../../assets/images/logo.svg';


import logoImage from '../../assets/images/header_logo2.svg';
import banner from '../../assets/images/signin_banner.jpg';
import showpasswordIcon from './assets/show.png';
import hidepasswordIcon from './assets/hide.png';


//import artwork from '../../assets/images/artwork.svg';
import axios from 'axios';
import BackDropLoading from '../../components/BackDropLoading.js';
import  { Redirect } from 'react-router-dom';

class Signin extends Component {



    constructor(props) {
        //alert("Hotel");
        super(props);
        this.state = {
            redirectUrl: "",
            // showCreate: false,
            // showDelete: false,
            // selectId: null,
            // selectMethod: "",
            loading: true,
            dataObject: null,
            validateObject:null,
            showPassword:"password",
            passwordIcon:hidepasswordIcon

        };
    }
    componentDidMount() {
        this.callGetData();
    }
    callGetData() {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/GetSigninData";
        //alert(url);
        let data = {};
        //alert("test");

        //data.searchObject = { ...this.state.searchObject };
        //data.Page = this.state.Page;


        axios
            .post(url, data, {
                headers: {
                    'Authorization': '123456'
                }
            })
            .then(response => {
                this.callGetDataCallBack(response.data.Data);
            })
            .catch(err => {
                console.error(err)
            })

        this.setState({
            loading: true
        })
    }
    callGetDataCallBack(data) {
        //console.log(data);
        
        this.setState({
            dataObject: { ...data.dataObject },
            validateObject: {...data.validateObject},
            loading: false
        })
    }
    handleChange =(e) =>{
        let dataObject = { ...this.state.dataObject };

        if(e.target.name === "Email") dataObject.Email = e.target.value;
        if(e.target.name === "Password") dataObject.Password = e.target.value;

        this.setState({
            dataObject: dataObject,
        })
    }
    handleClick = (method, index, value) => {
        if(method === "show_password"){
            let showPassword = this.state.showPassword;
            let passwordIcon = this.state.passwordIcon;
            showPassword = showPassword === "password" ? "text":"password";
            if(showPassword === "password"){
                passwordIcon = hidepasswordIcon;
            }
            else{
                passwordIcon = showpasswordIcon;
            }



            this.setState({
                showPassword: showPassword,
                passwordIcon:passwordIcon
            })   
        }
    }






    signinClick = (e)=>{
        this.callSignin();
    }
    callSignin(){
        //alert("xxx");
        let url = process.env.REACT_APP_API_END_POINT + "/api/Corp/Login";
        //alert(url);
        let data = {...this.state.dataObject};
        //alert("test");

        //data.searchObject = { ...this.state.searchObject };
        //data.Page = this.state.Page;


        axios
            .post(url, data, {
                headers: {
                    'Authorization': '123456'
                }
            })
            .then(response => {
                //console.log(response.data);
                this.callSigninCallBack(response.data);
            })
            .catch(err => {
                console.error(err)
            })

        // this.setState({
        //     loading: true
        // })
    }
    callSigninCallBack=(data)=>{
       // alert("res");
       console.log(data);
        if(data.Success === true){

            var dataObject = data.Data;
            //console.log(dataObject);
            window.localStorage.setItem("userObject", JSON.stringify(dataObject));

            //JSON.parse()

            //console.log("signin compleate");
            //console.log(dataObject);



            let link = "";

            if(dataObject.UserType === 0){
                link = "/Workflow";
            }
            if(dataObject.UserType ===1){
                if(dataObject.companyId !== null){
                    //alert(dataObject.companyId);
                    link = "/company/Workflow/"+dataObject.companyId;
                }
                else{
                    alert("error");
                }
                
            }
            this.setState({
                redirectUrl:link
            })

        }else{
            let validateObject = this.initialDataObject();
            validateObject.Password = data.Message;
            this.setState({
                validateObject: validateObject,
                loading: false
            })
            // this.setState({
            //     //dataObject: { ...data.dataObject },
            //     validateObject: {...data.validateObject},

            //     loading: false
            // })
        }
    }
    initialDataObject() {
        let dataObject = {};
        dataObject.Email = "";
        dataObject.Password = "";
        return dataObject;
    }







    // handleClick = (e) => {
    //     if (e.target.name === "Signin") {
    //         alert("signin");
    //     }
    // }

    render() {

        let dataObject = this.state.dataObject;
        let validateObject = this.state.validateObject;

        //console.log(dataObject);

        if(this.state.redirectUrl !== ""){
            return <Redirect from="*" to={this.state.redirectUrl} />
        }

        return (
            <div className={style.main}>
                <BackDropLoading show={this.state.loading} key="hotel" />

                <div className={style.content}>
                    <div className={style.r1}>
                        <div className={style.logo}>
                            <img src={logoImage} alt="logo" />
                        </div>
                    </div>
                    <div className={style.r2}>
                        <div className={style.r2c1}>
                            <img src={banner} alt="artwork" />
                        </div>

                        {this.state.dataObject != null &&
                            <div className={style.r2c2}>
                                <div className={style.loginArea}>
                                    <div className={style.title}>Company Management</div>
                                    <div className={style.subTitle}>Log-in</div>

                                    {/* <div className={style.spaceHeigh20}></div> */}

                                    <div className={style.inputBox}>
                                        <div className={style.inputLabel}>Email</div>
                                        <div className={style.textBoxArea}>
                                            {/* <i className="fas fa-envelope"></i> */}
                                            <input type="text" name="Email" value={dataObject.Email} onChange={this.handleChange}    placeholder="Enter your email." />
                                        </div>
                                        <div className={style.errorMessage}>{validateObject.Email}</div>
                                    </div>
                                    <div className={style.inputBox}>
                                        <div className={style.inputLabel}>Password</div>
                                        <div className={style.textBoxAreaPassword}>
                                            {/* <i className="fas fa-key"></i> */}
                                            <input type={this.state.showPassword} name="Password" onChange={this.handleChange} value={dataObject.Password} placeholder="Enter your password" />
                                            <img src={this.state.passwordIcon} alt="icon" onClick={(e) => this.handleClick("show_password", null, null)}/>
                                        </div>
                                        <div className={style.errorMessage}>{validateObject.Password}</div>
                                    </div>

                                    {/* <div className={style.option}>
                                        <div className={style.forgotBtn}>Forgot password</div>
                                    </div> */}


                                    <div className={style.btn} onClick={this.signinClick}>
                                        Sign In
                                    </div>
                                </div>
                            </div>

                        }
                    </div>
                </div>
            </div>
        );
    }
}
export default Signin




